import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../../constants/icons';
import './SuccessRegTemplate.css';
import {
  TextButton,
  TextButtonSize,
  TextButtonVariant,
} from '../../../Molecules';

type SuccessRegTemplateProps = {
  onClickContinue: () => void;
};

export const SuccessRegTemplate = memo(
  ({ onClickContinue }: SuccessRegTemplateProps) => {
    const { t } = useTranslation();
    return (
      <div className="successReg">
        <div className="centered-container">
          <section>
            <div className="text-content">
              <img className="tick-icon" src={Icons[IconType.Tick]} />
              <p className="text-3xl font-bold">{t('REGISTRATION COMPLETE')}</p>
              <p>
                {t(
                  'Congratulations! your account has been successfully created.',
                )}
              </p>
              <p className="text-black">
                {t('We have just sent you a verfication email.')}
                <br />
                {t('Please check your inbox')}
              </p>
              <p className="text-grey">
                {t('Please also check your spam folder / junk box.')}
              </p>
              <div className="button">
                <TextButton
                  text={t('Continue')}
                  size={TextButtonSize.Medium}
                  variant={TextButtonVariant.Cyan}
                  onClick={onClickContinue}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  },
);
